export const emailTemplateEmailTypes = {
  GENERAL_AFFILIATE: 'Advertiser Invite General Affiliate',
  KOL_INFLUENCER: 'Advertiser Invite KOL Influencer',
  DISCOUNT_LOYALTY: 'Advertiser Invite Discount Loyalty',
  PRODUCT_REVIEW: 'Advertiser Invite Product Review',
  INFORMATIONAL_GUIDE: 'Advertiser Invite Informational Guide',
  INCENTIVE_FOCUS: 'Advertiser Invite Incentive Focus',
};

export const emailTemplateSortedTypes = [
  emailTemplateEmailTypes.GENERAL_AFFILIATE,
  emailTemplateEmailTypes.KOL_INFLUENCER,
  emailTemplateEmailTypes.DISCOUNT_LOYALTY,
  emailTemplateEmailTypes.PRODUCT_REVIEW,
  emailTemplateEmailTypes.INFORMATIONAL_GUIDE,
  emailTemplateEmailTypes.INCENTIVE_FOCUS,
];
